import { $1 } from '@/lib/utils';

const dropmenu = $1('ul.header-dropmenu');
if (dropmenu) {
  bindHeightToCSSVar('header-measure', '--header-main-height');
  bindHeightToCSSVar('header-dropmenu', '--header-dropmenu-height');
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

function bindHeightToCSSVar(id: string, cssVar: string) {
  const el = document.getElementById(id);
  if (!el) return;

  const update = () => {
    document.documentElement.style.setProperty(cssVar, `${el.offsetHeight}px`);
  };

  update();
  window.addEventListener('resize', update);
  new ResizeObserver(update).observe(el);
}

function onScroll() {
  dropmenu!.classList.toggle('is-scrolled', window.scrollY > 8);
}
